module.exports = __webpack_public_path__ + "img/provisioner_token.37582c2a.png";